import { useState } from 'react';
import { Plus, X } from 'lucide-react';
import '../../styles/pages/FAQSection.css';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What services does Geotech offer?",
      answer: "Geotech provides a comprehensive range of geospatial technology solutions including GIS mapping, remote sensing, spatial analytics, and location intelligence services. We specialize in helping organizations harness the power of location data to make informed decisions and drive sustainable growth."
    },
    {
      question: "How can Geotech's solutions benefit my business?",
      answer: "Our geospatial solutions can transform your business operations by providing valuable location insights, improving decision-making processes, optimizing resource allocation, and identifying new opportunities. We help organizations across various industries leverage spatial data for strategic advantage."
    },
    {
      question: "Do you provide training on geospatial technologies?",
      answer: "Yes, we offer comprehensive training programs on various geospatial technologies including GIS software, remote sensing applications, and spatial analysis techniques. Our training services are designed for beginners to advanced users across different industries."
    },
    {
      question: "What industries do you serve?",
      answer: "We serve a diverse range of industries including urban planning, environmental management, agriculture, transportation, utilities, telecommunications, healthcare, and government sectors. Our solutions are tailored to meet the specific needs of each industry."
    },
    {
      question: "How long does it take to implement a geospatial project?",
      answer: "Project timelines vary depending on complexity and scope. Simple mapping projects may take a few weeks, while comprehensive spatial analytics implementations can take several months. We work closely with clients to establish realistic timelines and deliverables."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">Find answers to common questions about our services and solutions</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="faq-question"
              >
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-toggle">
                  {openIndex === index ? (
                    <X size={24} className="faq-icon" />
                  ) : (
                    <Plus size={24} className="faq-icon" />
                  )}
                </span>
              </button>
              
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}